import { Reducer } from 'redux';

import { OpportunitiesActionTypes } from './action-types';
import { initialState } from './constants';
import { OpportunitiesReducerState as State } from './types';

export const opportunitiesReducer: Reducer<State> = (state = initialState, action): State => {
  switch (action.type) {
    case OpportunitiesActionTypes.FETCH_OPPORTUNITIES.SUCCESS:
      return { ...state, list: action.payload };

    case OpportunitiesActionTypes.FETCH_OPPORTUNITY.START:
      return { ...state, opportunity: null, newOpportunity: null };

    case OpportunitiesActionTypes.FETCH_OPPORTUNITY.SUCCESS:
      return { ...state, opportunity: action.payload, newOpportunity: action.payload };

    case OpportunitiesActionTypes.FETCH_OPPORTUNITY.CLEAN_UP:
      return { ...state, opportunity: null, newOpportunity: null };

    case OpportunitiesActionTypes.ASSIGN_SALES_REPRESENTATIVE.START: {
      return { ...state, assignmentInProgress: true };
    }

    case OpportunitiesActionTypes.ASSIGN_SALES_REPRESENTATIVE.FAIL:
    case OpportunitiesActionTypes.ASSIGN_SALES_REPRESENTATIVE.SUCCESS:
    case OpportunitiesActionTypes.ASSIGN_SALES_REPRESENTATIVE.STOP: {
      return { ...state, assignmentInProgress: false };
    }

    default:
      return state;
  }
};
